export interface IUpdateAnatomyPrefsDataRequest {
    id: number,
    anatomyPrefArteriesLeft: number,
    anatomyPrefArteriesRight: number,
    anatomyPrefVeinsLeft: number,
    anatomyPrefVeinsRight: number
}